import React from "react";
import { Input } from "antd";
export default function Textarea({
  value,
  field,
  onChange,
  placeholder,
  opts = {}
}) {
  return (
    <Input.TextArea
      style={{ marginBottom: 5 }}
      name={field}
      value={value}
      placeholder={placeholder || "请输入"}
      onChange={e => onChange(e.target.value)}
      {...opts}
    />
  );
}
